export const Disclaimer = (props: any) => {
  const disclaimer =
    props.message ||
    `Answers are AI generated and may require further validation by referring to the original articles
    for precise and complete information.`;

  return (
    <div
      class="flex items-center justify-center p-4 text-sm text-[#737373] text-center"
      role="alert"
    >
      <div>
        <span class="font-medium">Disclaimer:</span> {disclaimer}
      </div>
    </div>
  );
};
